import { formatTitle } from "@itandi/tools/vanilla";
import Head from "next/head";

type Props = {
	title: string;
};

export function NskHead({ title }: Props) {
	return (
		<Head>
			<title>{formatTitle(title, "nsk")}</title>
		</Head>
	);
}
